import React from "react";
import driver from "../img/drivers.png";
import circuit from "../img/circuits.png";

export const Features = () => {
    return (
        <div className="features-container">
            <div className="gear-vis">
                <div className="gear-vis-header">
                    Gear Visualisation
                </div>

                <div className="gear-vis-body">
                    <ul>
                        <li>Compare the gear usage of 2 or more drivers</li>
                        <li>Analyse the average gear usage of the grid </li>     
                        <li>Select from many tracks + seasons</li>  
                    </ul>
                </div>
            </div>

            <div className="lap-time-comp">
                <div className="lap-time-comp-header">
                    Lap Time Comparison
                </div>

                <div className="lap-time-comp-body">
                    <ul>
                        <li>Compare the sector times from 2 or more drivers</li>
                        <li>Compare the lap times from 2 or more drivers</li>
                        <li>Modelled in an appealing bar chart + table UI</li>
                    </ul>
                </div>
            </div>

            <div className="ai-engineer">
                <div className="ai-engineer-header">
                    AI Engineer
                </div>

                <div className="ai-engineer-body">
                    <ul>
                        <li>Advice on where drivers could improve</li>
                        <li>Detailed explanations on why drivers <br /> lost time over the course of a lap</li>
                        <li>Imporve your overall understanding of a circuit</li>
                    </ul>
                </div>
            </div>
        </div>
    ); 
};

export const Range = ({ driverRef, trackRef }) => {
    return (
        <div className="range-container">
            <div className="driver-container" ref={driverRef}>
                <div className="driver-header">
                    Analyse 20+ drivers!
                </div>

                <div className="driver-img">
                    <img src={driver}/>
                </div>
            </div>

            <div className="circuit-container" ref={trackRef}>
                <div className="circuit-header">
                    Explore a wide range of circuits!
                </div>

                <div className="circuit-img">
                    <img src={circuit}/>
                </div>
            </div>
        </div>
    )
}

export default { Features, Range };